<img [src]="url" alt="image" [title]="url" [ngStyle]="{ width: width, height: height }" />
